import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Calendar, Star, Eye, BedDouble } from 'lucide-react';
import { revealVariants } from '../utils/animations';
const industries = [{
  id: 'clinicas',
  label: 'CLÍNICAS Y CONSULTORIOS',
  title: 'Confianza desde el primer clic.',
  desc: 'Transmití profesionalismo y facilitá la reserva de turnos online. Una web limpia que refleja la higiene y calidad de tu servicio médico.',
  features: ['Turnos online integrados', 'Perfiles de profesionales', 'Diseño ultra clean'],
  image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&q=80&w=1200',
  overlayCard: <div className="absolute bottom-6 left-6 right-6 md:left-6 md:right-auto md:w-72 bg-neutral-950/90 backdrop-blur-xl rounded-xl p-4 shadow-2xl border border-white/10" data-id="element-224">
        <div className="flex items-center justify-between mb-3" data-id="element-225">
          <div className="flex items-center space-x-2" data-id="element-226">
            <Calendar size={14} className="text-blue-400" data-id="element-227" />
            <span className="text-xs font-semibold text-white" data-id="element-228">
              Reservar turno
            </span>
          </div>
          <span className="text-[10px] text-green-400 font-medium" data-id="element-229">
            Disponible
          </span>
        </div>
        <div className="grid grid-cols-7 gap-1.5 mb-3" data-id="element-230">
          {[10, 11, 12, 13, 14, 15, 16].map((d, i) => <div key={i} className={`aspect-square rounded-md flex items-center justify-center text-[9px] font-medium ${i === 2 ? 'bg-blue-500 text-white' : 'bg-white/5 text-neutral-400'}`} data-id="element-231">
              {d}
            </div>)}
        </div>
        <div className="w-full h-7 bg-blue-500 rounded-md flex items-center justify-center text-white text-[10px] font-semibold" data-id="element-232">
          Confirmar 10:30 hs
        </div>
      </div>
}, {
  id: 'restaurantes',
  label: 'RESTAURANTES Y BARES',
  title: 'Una experiencia gourmet digital.',
  desc: 'Atraé comensales con un diseño elegante y fotografías que abren el apetito. Facilitá las reservas y mostrá tu menú con estilo.',
  features: ['Menú digital premium', 'Sistema de reservas', 'Estética luxury'],
  image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&q=80&w=1200',
  reverse: true,
  overlayCard: <div className="absolute bottom-6 left-6 right-6 md:right-6 md:left-auto md:w-72 bg-neutral-950/90 backdrop-blur-xl rounded-xl p-4 shadow-2xl border border-white/10" data-id="element-233">
        <div className="flex items-center space-x-1 mb-2" data-id="element-234">
          {[...Array(5)].map((_, i) => <Star key={i} size={11} className="fill-amber-400 text-amber-400" data-id="element-235" />)}
          <span className="text-[10px] text-neutral-400 ml-1" data-id="element-236">
            4.9 · 284 reseñas
          </span>
        </div>
        <div className="text-sm font-semibold text-white mb-1" data-id="element-237">
          Mesa para 2 · Hoy 21:00
        </div>
        <div className="text-[11px] text-neutral-400 mb-3" data-id="element-238">
          Confirmá tu reserva en 10 segundos
        </div>
        <div className="w-full h-7 bg-white text-black rounded-md flex items-center justify-center text-[10px] font-semibold" data-id="element-239">
          Reservar mesa
        </div>
      </div>
}, {
  id: 'negocios-retail',
  label: 'NEGOCIOS · RETAIL & FASHION',
  title: 'Diseño minimalista y moderno.',
  desc: 'Mostrá tus productos como piezas de diseño. Una estética limpia que resalta los detalles y posiciona tu marca en el segmento premium.',
  features: ['Catálogo visual', 'Estética fashion-tech', 'Integración WhatsApp'],
  image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?auto=format&fit=crop&q=80&w=1200',
  overlayCard: <div className="absolute bottom-6 left-6 right-6 md:left-6 md:right-auto md:w-72 bg-neutral-950/90 backdrop-blur-xl rounded-xl p-4 shadow-2xl border border-white/10" data-id="element-240">
        <div className="flex items-center space-x-2 mb-3" data-id="element-241">
          <Eye size={14} className="text-cyan-400" data-id="element-242" />
          <span className="text-xs font-semibold text-white" data-id="element-243">
            Colección Premium 2026
          </span>
        </div>
        <div className="grid grid-cols-3 gap-2 mb-3" data-id="element-244">
          <div className="aspect-square rounded-md overflow-hidden border border-white/10" data-id="element-245">
            <img src="https://cdn.magicpatterns.com/uploads/obnHcS9kJHkHt46q1AmBmJ/giorgio-trovato-K62u25Jk6vo-unsplash.jpg" alt="Lentes Wayfarer" className="w-full h-full object-cover" loading="lazy" data-id="element-246" />
          </div>
          <div className="aspect-square rounded-md overflow-hidden border border-white/10" data-id="element-247">
            <img src="https://cdn.magicpatterns.com/uploads/3HQz3xv8SK2SoHha9eY7Xo/claudio-schwarz-e8TtkC5xyv4-unsplash.jpg" alt="Lentes de receta" className="w-full h-full object-cover" loading="lazy" data-id="element-248" />
          </div>
          <div className="aspect-square rounded-md overflow-hidden border border-white/10" data-id="element-249">
            <img src="https://cdn.magicpatterns.com/uploads/tZceyNMnpwEmWKyr9xpWwx/charlesdeluvio-1-nx1QR5dTE-unsplash.jpg" alt="Lentes redondos vintage" className="w-full h-full object-cover" loading="lazy" data-id="element-250" />
          </div>
        </div>
        <div className="text-[10px] text-neutral-400" data-id="element-251">
          Desde <span className="font-bold text-white" data-id="element-252">$3.500</span>
        </div>
      </div>
}, {
  id: 'negocios-boutique',
  label: 'NEGOCIOS · BOUTIQUE & TURISMO',
  title: 'Lujo digital y reservas directas.',
  desc: 'Evitá comisiones de terceros con una web que enamore a tus clientes antes de llegar. Visuales cinemáticas y proceso de reserva fluido.',
  features: ['Motor de reservas', 'Galería inmersiva', 'Experiencia boutique'],
  image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&q=80&w=1200',
  reverse: true,
  overlayCard: <div className="absolute bottom-6 left-6 right-6 md:right-6 md:left-auto md:w-72 bg-neutral-950/90 backdrop-blur-xl rounded-xl p-4 shadow-2xl border border-white/10" data-id="element-253">
        <div className="flex items-center justify-between mb-3" data-id="element-254">
          <div className="flex items-center space-x-2" data-id="element-255">
            <BedDouble size={14} className="text-purple-400" data-id="element-256" />
            <span className="text-xs font-semibold text-white" data-id="element-257">
              Suite Premium
            </span>
          </div>
          <span className="text-[10px] font-bold text-white" data-id="element-258">USD 280</span>
        </div>
        <div className="flex items-center space-x-2 mb-3 text-[10px] text-neutral-400" data-id="element-259">
          <span className="px-2 py-0.5 bg-white/5 rounded" data-id="element-260">
            Check-in 12 Mar
          </span>
          <span className="px-2 py-0.5 bg-white/5 rounded" data-id="element-261">
            Check-out 15 Mar
          </span>
        </div>
        <div className="w-full h-7 bg-gradient-to-r from-purple-600 to-purple-700 rounded-md flex items-center justify-center text-white text-[10px] font-semibold" data-id="element-262">
          Reservar 3 noches
        </div>
      </div>
}];
export function IndustryShowcase() {
  return <section id="industrias" className="py-20 md:py-32 relative" data-id="element-263">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-32" data-id="element-264">
        {industries.map(ind => <motion.div key={ind.id} variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className={`flex flex-col ${ind.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-24 items-center`} data-id="element-265">
            <div className="flex-1 space-y-6" data-id="element-266">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/5 border border-white/10" data-id="element-267">
                <span className="text-xs font-bold tracking-wider text-neutral-400 uppercase" data-id="element-268">
                  {ind.label}
                </span>
              </div>
              <h3 className="text-4xl md:text-5xl font-bold tracking-tighter text-white" data-id="element-269">
                {ind.title}
              </h3>
              <p className="text-lg text-neutral-400 font-light leading-relaxed" data-id="element-270">
                {ind.desc}
              </p>
              <ul className="space-y-3 pt-4" data-id="element-271">
                {ind.features.map((feat, i) => <li key={i} className="flex items-center text-neutral-300" data-id="element-272">
                    <CheckCircle2 size={18} className="text-neon mr-3" data-id="element-273" />
                    {feat}
                  </li>)}
              </ul>
            </div>

            <div className="flex-1 w-full" data-id="element-274">
              <div className="relative aspect-[4/3] w-full max-w-lg mx-auto lg:mx-0 group" data-id="element-275">
                <div className="absolute inset-0 bg-white/[0.02] border border-white/5 rounded-2xl transform rotate-2 scale-[1.02] transition-transform duration-700 group-hover:rotate-0" data-id="element-276"></div>

                <div className="relative aspect-[4/3] w-full rounded-2xl overflow-hidden border border-white/10 shadow-2xl z-10" data-id="element-277">
                  <img src={ind.image} alt={ind.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-278" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-279"></div>
                  {ind.overlayCard}
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}